import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
      data-product-shop
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-100">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 女神漫画下拉式在线阅读`}
          title={`${comic.title} - 女神漫画下拉式免费全集`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span
            className={`px-2 py-0.5 rounded text-xs font-medium ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2">
            <span className="text-xs text-white/80 bg-white/20 px-1.5 py-0.5 rounded">
              {comic.category}
            </span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
        {comic.title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500">{comic.author}</span>
        <span className="flex items-center gap-0.5 text-xs text-amber-500">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}